/**
 * @file 防抖
 * @author caierwei<caierwei@baijia.com>
 * @module util/debounce
 */
var DEFAULT_SHRESHHOLD = 250;

/**
  * 函数限流
  *
  * @function debounce
  * @param {Function} fn 需要做限流处理的函数
  * @param {number=} [delay=250] 防抖时间阈值，单位毫秒，默认为 250
  * @param {boolean=} 是否立即触发
  * @param {*=} bind 针对 fn 最终调用时需要绑定的 this
  * @return {Function} 返回包装过带防抖功能的 fn
  */

export default function debounce(fn) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_SHRESHHOLD;
  var immediate = arguments.length > 2 ? arguments[2] : undefined;
  var bind = arguments.length > 3 ? arguments[3] : undefined;
  var timer;
  var result;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (timer) {
      clearTimeout(timer);
    }
    if (immediate) {
      // 如果timer存在，说明第二次调用的时候还没到delay时间，因为如果超过delay时间
      // timer会被赋值为null，所以这个时候我们不应该执行fn，应该重新设置一个定时器
      // 但如果是一次的时候，因为还没有设过定时器，所以这里timer会是undefined
      if (timer) {
        timer = setTimeout(function () {
          timer = null;
        }, delay);
      } else {
        result = fn.apply(bind, args);
        return result;
      }
    } else {
      timer = setTimeout(function () {
        return fn.apply(bind, args);
      }, delay);
    }
  };
}